import { validateCprAge } from '@flos/react-ui';

const isCprTooOldForFlavour = (cpr: string, flavour: string): boolean => {
    const turnFullAgeInDays = new Date();
    turnFullAgeInDays.setDate(turnFullAgeInDays.getDate() + 40);
    return (
        (flavour === 'Ulykkesforsikring' &&
            validateCprAge(cpr, { maxAge: 79, currentTime: turnFullAgeInDays.getTime() }) ===
                'TOO_OLD') ||
        ((flavour === 'Ulykkesforsikring til unge' || flavour === 'Indboforsikring til unge') &&
            validateCprAge(cpr, { maxAge: 27, currentTime: turnFullAgeInDays.getTime() }) ===
                'TOO_OLD')
    );
};

const isAgeTooOldForFlavour = (age: number, flavour: string): boolean => {
    return (
        (flavour === 'Ulykkesforsikring' && age > 79) ||
        ((flavour === 'Ulykkesforsikring til unge' || flavour === 'Indboforsikring til unge') &&
            age > 27)
    );
};

export { isCprTooOldForFlavour, isAgeTooOldForFlavour };
